import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import * as AccountStepsViews from './AccountsStepViews';
import { isVisible } from '../../../AdvWorkflow/AdvWorkflowHelpers';

import AccountsOverview from './AccountsOverviewContainer';
import AccountAddEdit from './AccountAddEditContainer';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../../../DecumulationWorkflow/DecumulationWorkflow.constants';

class AccountsStepView extends Component {
  componentDidUpdate(prevProps) {
    const { branch, iterator, workflowId, clientId, fetchData, dirtyNodesMap } = this.props;

    if (!isVisible(prevProps.branch, prevProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId, dirtyNodesMap);
    }
  }

  render() {
    const {
      branch,
      workflowId,
      viewId,
      hasYourFamilyStartedSaving,
      alreadyHasYourFamilyStartedSavingData,
    } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={
          workflowId !== DECUMULATION_WORKFLOW_ID &&
          !hasYourFamilyStartedSaving &&
          !alreadyHasYourFamilyStartedSavingData
        }
        {...(viewId === AccountStepsViews.OVERVIEW
          ? {
              id: 'AccountsOverviewViewStep',
            }
          : {})}
      >
        {viewId === AccountStepsViews.OVERVIEW && (
          <AccountsOverview branch={branch} workflowId={workflowId} />
        )}
        {(viewId === AccountStepsViews.ADD || viewId === AccountStepsViews.EDIT) && (
          <AccountAddEdit branch={branch} workflowId={workflowId} />
        )}
      </AdvWorkflowStep>
    );
  }
}

AccountsStepView.defaultProps = {
  iterator: null,
  hasYourFamilyStartedSaving: null,
};

AccountsStepView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number),
  workflowId: PropTypes.string.isRequired,
  viewId: PropTypes.oneOf(Object.values(AccountStepsViews)).isRequired,

  hasYourFamilyStartedSaving: PropTypes.bool,
  fetchData: PropTypes.func.isRequired,
  alreadyHasYourFamilyStartedSavingData: PropTypes.bool.isRequired,
  dirtyNodesMap: PropTypes.shape({}).isRequired,
};

export default AccountsStepView;
